import styled from "styled-components";
import { BACKGROUND_COLORS, BORDER_COLORS, COLORS, TEXT_COLORS } from "../../constants/design/colors";
import { COMPONENTS, SPACING } from "../../constants/design/spacing";
import { FONT_SIZE, FONT_STYLE } from "../../constants/design/fontSize";
import { GreekStatsWrapper } from "../Account/stats/style";

export const BookWrapper = styled.div`
  height: calc(100vh - ${COMPONENTS.header.main + SPACING.three}px);
  padding-bottom: ${SPACING.three}px;
  overflow-x: hidden;
  overflow-y: scroll;
`;

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  background: ${BACKGROUND_COLORS.five};
  z-index: 100;
  padding: ${SPACING.two}px 0;
  border-top: 1px solid ${BORDER_COLORS.two};
  border-bottom: 1px solid ${BORDER_COLORS.two};

  > * {
    margin: 0 ${SPACING.three}px;
    max-width: 100%;
  }

  > ${GreekStatsWrapper} {
    padding-top: ${SPACING.three}px;
    width: inherit;
  }
`;

export const AddressHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: calc(100vw - ${SPACING.three * 2}px);
  padding-bottom: ${SPACING.three}px;
  margin-top: ${SPACING.one}px;
`;

export const TableWrapper = styled.div`
  margin: 0 ${SPACING.three}px;
`;

export const AddressTag = styled.span<{ isActive?: boolean }>`
  background: ${BACKGROUND_COLORS.component};
  padding: ${SPACING.two}px;
  ${FONT_STYLE.data.three};
  border-radius: 6px;
  position: relative;
  padding-right: ${SPACING.two * 2 + 6}px;
  transition: 0.1s all ease-in-out;
  border: 1px solid ${BORDER_COLORS.two};

  &::before {
    content: "";
    position: absolute;
    right: ${SPACING.two}px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ isActive }) => (isActive ? COLORS.green.one : BACKGROUND_COLORS.eight)};
  }

  &:not(:last-of-type) {
    margin-right: ${SPACING.two}px;
  }

  &:hover {
    cursor: pointer;
    border: 1px solid ${COLORS.blue.one};
  }
`;

export const LastUpdatedText = styled.div`
  display: inline-flex;
  ${FONT_STYLE.label.two};
  color: ${TEXT_COLORS.two};

  > span {
    color: ${TEXT_COLORS.one};
    margin-left: ${SPACING.one}px;
  }
`;

export const SelectWrapper = styled.div`
  padding: 5px 15px;
`;
